/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Next_SlideInputs */



/**
* | output |
* | --- |
* | "Next slide" |
*
* @param {Next_SlideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const next_slide = /** @type {((inputs?: Next_SlideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_SlideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diapositive suivante")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächste Folie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Diapositiva successiva")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Следующий слайд")
	if (locale === "es") return /** @type {LocalizedString} */ ("Siguiente diapositiva")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下一张幻灯片")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のスライド")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगली स्लाइड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Próximo slide")
	return /** @type {LocalizedString} */ ("Next slide")
});